import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    activeCart: {
        activeCart: false,
        cartRemoval: 0,
        gracePeriod: 0,
        delay: 0,
    },
    donation: {
        stores: '',
        zone: 0,
    },
    lastVersion: '',
    minimumRequiredVersion: '',
    multiCountryShipping: false,
};

const configs = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.SET_BACKEND_CONFIG:
        return {
            ...state,
            ...action.payload,
        };
    case APP_ACTIONS.CONFIG_SET_MULTI_COUNTRY_SHIPPING:
        return {
            ...state,
            multiCountryShipping: action.payload,
        };
    default:
        return state;
    }
};

export default configs;



/** WEBPACK FOOTER **
 ** ./src/reducers/configs.js
 **/